import { FC, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const SetPrivacy: FC = () => {
  const params = useParams<{lang: string}>()

  useEffect(() => {
    const langParam = params.lang
    const lang = langParam || 'en'

    window.location.href = `https://www.set.or.th/${lang}/privacy-notice`;
  }, [params.lang]);

  return <div></div>;
};

export default SetPrivacy;
